/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
    this.bindProtezioneCheckbox();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }

  /**
   * Protezione di Consegna — voegt variant toe of verwijdert hem bij toggle.
   * Na een succesvolle AJAX-call wordt de drawer gefreshed zodat de
   * Liquid-state (checked/unchecked) en het cartbedrag kloppen.
   */
  bindProtezioneCheckbox() {
    document.addEventListener('change', (e) => {
      const cb = e.target;
      if (cb.id !== 'protezione-checkbox') return;

      cb.disabled = true;
      const variantId = parseInt(cb.dataset.variantId, 10);

      const endpoint = cb.checked ? '/cart/add.js' : '/cart/change.js';
      const payload  = cb.checked
        ? { id: variantId, quantity: 1 }
        : { id: variantId, quantity: 0 };

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
      .then((res) => {
        if (!res.ok) throw new Error('cart-error');
        return res.json();
      })
      .then(() => {
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }, 300);
      })
      .catch(() => {
        // Revert checkbox bij fout (bijv. out-of-stock)
        cb.checked = !cb.checked;
        cb.disabled = false;
      });
    });
  }
}

window.customElements.define('cart-drawer', CartDrawer);